import React, { useEffect, useRef, useState } from 'react';
import { isNotEmpty } from '../../lib/ep.js';

import PublicGameStats from '../builder/PublicGameStats.js';
import { localizeFields } from '../builder/DynamicFields.js';

const FaceOffStats = ({ stage, ...props }) => {
	const players = localizeFields((props?.players ?? []), props.locale);
	const stats = props?.stats ?? {};
	const is_builder = props?.is_builder ?? false;

	const stats_count = props?.max_items ?? '3';

	const total_plays = useRef(0);
	const [ players_with_amount, setPlayersWithAmount ] = useState([]);

	const sortPlayersByAmount = () => {
		if(players.length == 0) return [];

		const _temp = [];

		players.map((player, i) => {
			const value = (!is_builder) ? parseInt((isNotEmpty(stats, player.id)) ? stats[player.id] : 0) : parseInt((i * 10 + 100) * Math.random());
			total_plays.current += value;

			_temp.push({
				id:player.id,
				name:player?.name ?? player.title,
				image:player.full_image,
				value,
			});
		});

		_temp.sort((a, b) => {
			if(a.value > b.value) return -1;
			if(a.value < b.value) return 1;
			return 0;
		});
		setPlayersWithAmount((stats_count != 'all') ? _temp.slice(0, parseInt(stats_count)) : _temp);
	};

	useEffect(() => {
		sortPlayersByAmount();
	}, [ props.max_items ]);

	return (
		<PublicGameStats
			items={players_with_amount}
			total={total_plays.current}
			actual_selection={props.actual_selection}
			display_abs_stats={props?.display_abs_stats ?? true}
			intl={props.intl}
		/>
	)
};

export default FaceOffStats;